import React from 'react'
import { FaTwitter } from 'react-icons/fa'
import data from '../data/testimonials'

const Testimonials = () => {
  // eslint-disable-next-line
  const [cards, setCards] = React.useState(data)

  return (
    <>
      <h2 className="text-center text-4xl text-gray-800 font-bold mb-5">
        What do people say about us?
      </h2>
      <section className="grid grid-cols-1 gap-5 px-5 pb-20 sm:grid-cols-2 xl:px-32 2xl:px-56">
        {cards.map((card) => {
          const { id, fullName, desc, twitter } = card
          return (
            <div
              key={id}
              className="bg-blue-100 py-2 px-5 rounded transition-all hover:shadow-lg"
            >
              <h3 className="flex items-center justify-between font-bold tracking-wide mb-2 text-gray-800 text-2xl">
                {fullName}
                <a
                  href={twitter}
                  target="_blank"
                  rel="noopenner noreferrer"
                  className="text-blue-500 inline-block text-xl"
                >
                  <FaTwitter />
                </a>
              </h3>
              <p className="mb-2 text-gray-800 text-lg">{desc}</p>
            </div>
          )
        })}
      </section>
    </>
  )
}

export default Testimonials
